import { useAssessmentStore } from '../../store/useAssessmentStore';

export const Hero = ({ title, description }: { title?: string; description?: string }) => {
  const assessmentPage = useAssessmentStore((state) => state.assessmentPage);

  if (!assessmentPage) return <></>;

  return (
    <>
      <div className="mt-5">
        <h1 className="mb-2 font-cadiz text-sh-28-32 font-bold">{title || assessmentPage?.title}</h1>
        <p
          className="arrow-scope quote-scope mt-2 font-cadiz text-base text-gray-600"
          dangerouslySetInnerHTML={{
            __html: description || assessmentPage?.description || '',
          }}
        />
      </div>
    </>
  );
};
